import { render, staticRenderFns } from "./editTurnoverTier.vue?vue&type=template&id=aabb5a08&lang=pug"
import script from "./editTurnoverTier.vue?vue&type=script&lang=js"
export * from "./editTurnoverTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports